import { Clear, LocalPrintshopOutlined, Search } from "@mui/icons-material";
import {
  Alert,
  Autocomplete,
  Box,
  Chip,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Snackbar,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

import useStyles from "./styles";
import dayjs from "dayjs";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import DatagridComponent from "../../../../components/datagridComponent";
import customParseFormat from "dayjs/plugin/customParseFormat";
import FilterBar from "../../../../components/topBarFilter";
import VirtualizedAutocomplete from "../../../../components/virtualization/virtualizedAutocomplete";
import ErpFilter from "../../../../components/erp/ErpFilter";
import useErpSelecionado from "../../../../components/erp/useErpSelecionado";
import { getClienteOptionLabel } from "../../../../components/grupoEconomico/helpers";
import {
  CampoCliente,
  renderOpcaoCliente,
} from "../../../../components/opcaoCliente";
dayjs.extend(customParseFormat);

function erpConfig(erp, invertInfo) {
  let erpObj = { isNf: false, columnsErpType: "", labelErp: "" };

  switch (erp) {
    case "HUBSOFT":
      erpObj = {
        isNf: true,
        columnsErpType: erp.toLowerCase(),
        labelErp: "Serviço",
        labelRef: invertInfo ? "Serviço" : "Referência",
      };
      break;

    case "VOALLE":
      erpObj = {
        isNf: false,
        columnsErpType: erp.toLowerCase(),
        labelErp: "Contrato",
      };
      break;
    case "IXC":
      erpObj = {
        isNf: false,
        columnsErpType: erp.toLowerCase(),
        labelErp: "Contrato",
        labelRef: invertInfo ? "Serviço" : "Referência",
      };
      break;
    case "VERO":
      erpObj = {
        isNf: false,
        columnsErpType: erp.toLowerCase(),
        labelErp: "Contrato",
      };
      break;
  }
  return erpObj;
}

export default function Boletos() {
  const theme = useTheme();
  const styles = useStyles(theme);

  // ERP escolhido: a tela (colunas, NF, textos) é a dele, com os clientes dele.
  const { erps, erpId, setErpId, erp, carregado, variosErps } =
    useErpSelecionado(null, true);
  const { isNf, columnsErpType, labelErp } = erpConfig(erp);
  const [snackbar, setSnackbar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [allServices, setAllService] = useState([]);
  const [rows, setRows] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [buscarFatura, setBuscarFatura] = useState("");
  const [selectService, setSelectService] = useState({});
  //TIPOS DE NF
  const [allNfs, setAllNfs] = useState([]); //Todas as notas
  const [rowsNf, setRowsNf] = useState([]);
  const [notasFiscais, setNotasFiscais] = useState([]); //Notas fiscais modelo 21/22
  const [nfes, setNfes] = useState([]); //Notas fiscais modelo 55 (NFE)
  const [nfses, setNfses] = useState([]); //Notas fiscais modelo PREFEITURA (NFSE)
  const [nfcoms, setNfcoms] = useState([]); //Notas fiscais modelo 62 (NFCOM)
  const [loadingNf, setLoadingNf] = useState(false);
  const [buscarNf, setBuscarNf] = useState("");
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [allModeloNf, setAllModeloNf] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [clienteInfo, setClienteInfo] = useState(null);
  const [selectModelo, setSelectModelo] = useState("");
  const { controllerDashboard, setControllerDashboard, api } =
    useOutletContext();
  useEffect(() => {
    apiGetClientes();
  }, []);
  const configErpRef = (invertInfo) => {
    switch (erp) {
      case "HUBSOFT":
        return {
          labelRef: invertInfo ? "Serviço" : "Referência",
        };
        break;
      case "IXC":
        return {
          labelRef: invertInfo ? "Contrato" : "Descrição auxiliar",
        };
        break;
      default:
        return {
          labelRef: "",
        };
        break;
    }
  };

  useEffect(() => {
    if (selectedCliente) {
      setClienteInfo(selectedCliente);
    }
  }, [selectedCliente]);

  // Cliente do ERP escolhido: o próprio ou, no grupo econômico, algum membro.
  const doErp = (cliente) =>
    !erpId ||
    cliente?.erpId === erpId ||
    (cliente?.isGrupoEconomico &&
      cliente?.membros?.some((membro) => membro?.erpId === erpId));

  useEffect(() => {
    if (!carregado) return;
    const selectedClientStorage = JSON.parse(
      localStorage.getItem("filterData"),
    );
    if (selectedClientStorage) {
      // Cliente salvo de outro ERP não é restaurado.
      const selectClient = clientes?.find(
        (cliente) =>
          cliente?.id === selectedClientStorage?.clienteId && doErp(cliente),
      );

      setSelectedCliente(selectClient || null);
    }
  }, [clientes, carregado]);

  // Troca de ERP: limpa cliente, faturas e notas (são do ERP anterior).
  const handleChangeErp = (novoErpId) => {
    if (!novoErpId || novoErpId === erpId) return;
    setSelectedCliente(null);
    setClienteInfo(null);
    setRows([]);
    setRowsNf([]);
    setAllNfs([]);
    setAllService([]);
    setSelectService(null);
    setErpId(novoErpId);
  };

  useEffect(() => {
    if (clienteInfo?.id) {
      fetchAllData();
    }
  }, [clienteInfo]);

  useEffect(() => {
    setRowsNf(
      selectModelo?.id === 1
        ? notasFiscais
        : selectModelo?.id === 2
          ? nfes
          : selectModelo?.id === 3
            ? nfses
            : selectModelo?.id === 4
              ? nfcoms
              : allNfs,
    );
  }, [selectModelo]);

  const apiGetClientes = async () => {
    setLoading(true);
    if (controllerDashboard) {
      controllerDashboard.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    try {
      const response = await api.get("/interno/getClients", { signal });

      setClientes(response.data);
      const selectedClientStorage = JSON.parse(
        localStorage.getItem("filterData"),
      );

      if (!selectedClientStorage || !selectedClientStorage?.clienteId) {
        setLoading(false);
      }
      if (selectedClientStorage) {
        const selectClient = response?.data?.find(
          (cliente) => cliente?.id === selectedClientStorage?.clienteId,
        );
        setSelectedCliente(selectClient);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const fetchAllData = async () => {
    try {
      switch (erp) {
        case "HUBSOFT":
          await Promise.all([getFaturas(), getNfs()]);
          break;

        case "VOALLE":
          await getFaturas();
          break;

        case "IXC":
          await getFaturas();
          break;
        case "VERO":
          await getFaturas(clienteInfo?.clienteErpId);
          break;

        default:
          setSnackbar({
            children: "ERP não foi configurado",
            severity: "warning",
          });
          break;
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  //Função para uso exclusivo do voalle
  async function downloadFatura(faturaId) {
    try {
      window.open(
        (window?.config?.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL) +
          `/download/voalle/fatura?faturaId=${faturaId}`,
        "_blank",
      );
    } catch {
    } finally {
    }
  }

  const getFaturas = async (clienteErpId) => {
    try {
      setAllService([]);
      setSelectService(null);
      setBuscarFatura("");
      setLoading(true);

      const response = await api.post("/interno/find/faturas", {
        clienteId: clienteInfo?.id,
        clienteErpId: clienteErpId,
      });

      setRows(
        response?.data?.faturas?.map((fatura) => ({
          id: fatura?.id_fatura,
          ...fatura,
        })),
      );

      setAllService(response?.data?.servicos || []);
    } catch (error) {
      console.error("Error fetching faturaws:", error);
      setSnackbar({
        children: "Erro ao buscar faturas",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const getNfs = async () => {
    setSelectModelo(null);
    setLoadingNf(true);
    try {
      const response = await api.post("/interno/find/nf", {
        clienteId: clienteInfo?.id,
      });

      setAllModeloNf(response?.data?.modelos);
      const notasFiscais = response?.data?.notas_fiscais;

      const nfes = response?.data?.nfes;
      const nfses = response?.data?.nfses;
      const nfcoms = response?.data?.nfcoms;

      setNotasFiscais(response?.data?.notas_fiscais);
      setNfes(response?.data?.nfes);
      setNfses(response?.data?.nfses);
      setNfcoms(response?.data?.nfcoms);

      const allNotas = [...notasFiscais, ...nfes, ...nfses, ...nfcoms];
      setRowsNf(allNotas);
      setAllNfs(allNotas);
    } catch (error) {
      console.error("Error fetching faturaws:", error);
      setSnackbar({
        children: "Erro ao buscar NFs",
        severity: "error",
      });
    } finally {
      setLoadingNf(false);
    }
  };

  const statusPagamento = {
    pago: <Chip sx={styles.chipPago} label={"Pago"} />,
    aguardando: <Chip sx={styles.chipAguardando} label={"Aguardando"} />,
    vencido: <Chip sx={styles.chipVencido} label={"Vencido"} />,
    "a receber": <Chip sx={styles.chipAguardando} label={"A receber"} />,
    "em atraso": <Chip sx={styles.chipVencido} label={"Em atraso"} />,
    cancelado: <Chip sx={styles.chipCancelado} label={"Cancelado"} />,
    recebido: <Chip sx={styles.chipPago} label={"Recebido"} />,
    renegociado: <Chip sx={styles.chipRenegociado} label={"Renegociado"} />,
  };

  const columnsHubsoft = [
    // Grupo econômico: exibe o cliente membro dono de cada fatura
    ...(clienteInfo?.isGrupoEconomico
      ? [
          {
            field: "ownerNome",
            headerName: "Cliente",
            flex: 1,
            renderCell: (params) => params?.row?.ownerNome || "",
          },
        ]
      : []),
    {
      field: "servico",
      headerName: "Serviço",
      flex: 1.5,
      valueGetter: (params, row) =>
        `${row?.servico?.id_cliente_servico} - ${row?.servico?.nome}`,

      renderCell: (params) => {
        const servico = params.row.cliente?.servico;
        if (!servico) return "";
        return `${servico.id_cliente_servico} - ${servico.nome}`;
      },
    },
    {
      field: "valor",
      headerName: "Valor da fatura",
      flex: 1,
      renderCell: (params) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(Number(params?.value || 0)),
    },
    {
      field: "data_vencimento",
      headerName: "Data Vencimento",
      flex: 1,
      valueGetter: (params) => dayjs(params, "DD/MM/YYYY", true).toDate(),
      renderCell: (params) => dayjs(params.value).format("DD/MM/YYYY"),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => statusPagamento[params?.value],
    },
    {
      field: "data_cadastro",
      headerName: "Data de cadastro",
      flex: 1,
      valueGetter: (params) => dayjs(params, "DD/MM/YYYY", true).toDate(),
      renderCell: (params) => dayjs(params.value).format("DD/MM/YYYY"),
    },
    {
      field: "valor_pago",
      headerName: "Valor Pago",
      flex: 1,
      renderCell: (params) =>
        params?.value
          ? new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(Number(params?.value || 0))
          : "",
    },
    {
      field: "data_pagamento",
      headerName: "Data de pagamento",
      flex: 1,
      valueGetter: (params) =>
        params ? dayjs(params, "DD/MM/YYYY", true)?.toDate() : "",
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD/MM/YYYY") : "",
    },

    {
      field: " ",
      headerName: " ",
      maxWidth: 16,
      sortable: false,

      renderCell: (params) => (
        <IconButton
          onClick={() =>
            window.open(params.row.link, "_blank", "noopener,noreferrer")
          }
          size="small"
        >
          <LocalPrintshopOutlined fontSize="small" />
        </IconButton>
      ),
    },
  ];

  const columnsIxc = [
    // Grupo econômico: exibe o cliente membro dono de cada fatura
    ...(clienteInfo?.isGrupoEconomico
      ? [
          {
            field: "ownerNome",
            headerName: "Cliente",
            flex: 1,
            renderCell: (params) => params?.row?.ownerNome || "",
          },
        ]
      : []),
    {
      field: "servico",
      headerName: "Serviço",
      flex: 1.5,
      valueGetter: (params, row) => `${row?.id_cliente_servico} - ${row?.nome}`,

      renderCell: (params) => {
        if (!params?.row?.id_cliente_servico && !params?.row?.nome) return "";
        return `${params?.row?.id_cliente_servico} - ${params?.row?.nome}`;
      },
    },
    {
      field: "valor",
      headerName: "Valor da fatura",
      flex: 1,
      renderCell: (params) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(Number(params?.value || 0)),
    },
    {
      field: "num_cobranca",
      headerName: "Nº de cobrança",
      flex: 1,
    },
    {
      field: "data_vencimento",
      headerName: "Data Vencimento",
      flex: 1,

      renderCell: (params) => {
        return dayjs(params.value).format("DD/MM/YYYY");
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => statusPagamento[params?.value],
    },
    {
      field: "data_cadastro",
      headerName: "Data de cadastro",
      flex: 1,

      renderCell: (params) => dayjs(params.value).format("DD/MM/YYYY"),
    },
    {
      field: "valor_pago",
      headerName: "Valor Pago",
      flex: 1,
      renderCell: (params) =>
        params?.value
          ? new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(Number(params?.value || 0))
          : "",
    },
    {
      field: "data_pagamento",
      headerName: "Data de pagamento",
      flex: 1,

      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD/MM/YYYY") : "",
    },

    {
      field: " ",
      headerName: " ",
      maxWidth: 16,
      sortable: false,
      renderCell: (params) => {
        const isValidUrl = (urlString) => {
          if (!urlString) return false;

          try {
            const url = new URL(urlString);

            return url.protocol === "http:" || url.protocol === "https:";
          } catch (error) {
            return false;
          }
        };

        const isLinkValid = isValidUrl(params?.row?.link);

        return (
          <IconButton
            disabled={!isLinkValid}
            onClick={() => {
              if (isLinkValid) {
                window.open(params.row.link, "_blank", "noopener,noreferrer");
              }
            }}
            size="small"
            title={
              !isLinkValid
                ? "Link de impressão indisponível"
                : "Imprimir fatura"
            }
          >
            <LocalPrintshopOutlined fontSize="small" />
          </IconButton>
        );
      },
    },
  ];

  const columnsVoalle = [
    // Grupo econômico: exibe o cliente membro dono de cada fatura
    ...(clienteInfo?.isGrupoEconomico
      ? [
          {
            field: "ownerNome",
            headerName: "Cliente",
            flex: 1,
            renderCell: (params) => params?.row?.ownerNome || "",
          },
        ]
      : []),
    {
      field: "servico",
      headerName: "Serviço",
      flex: 1.5,
      valueGetter: (params, row) =>
        `${row?.servico?.id_cliente_servico} - ${row?.servico?.nome}`,

      renderCell: (params) => {
        const servico = params.row.cliente?.servico;
        if (!servico) return "";
        return `${servico?.id_cliente_servico || ""} - ${servico?.nome || ""}`;
      },
    },
    {
      field: "valor",
      headerName: "Valor da fatura",
      flex: 1,
      renderCell: (params) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(Number(params?.value || 0)),
    },
    {
      field: "data_vencimento",
      headerName: "Data Vencimento",
      flex: 1,
      valueGetter: (params) => dayjs(params, "DD/MM/YYYY", true).toDate(),
      renderCell: (params) => dayjs(params.value).format("DD/MM/YYYY"),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => statusPagamento[params?.value],
    },
    {
      field: "valor_pago",
      headerName: "Valor pago",
      flex: 1,
      renderCell: (params) =>
        params?.value &&
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(Number(params?.value || 0)),
    },
    {
      field: "data_pagamento",
      headerName: "Data pagamento",
      flex: 1,
      valueGetter: (params) =>
        params && dayjs(params, "DD/MM/YYYY", true).toDate(),
      renderCell: (params) =>
        params.value && dayjs(params.value).format("DD/MM/YYYY"),
    },
    {
      field: "data_cadastro",
      headerName: "Data de cadastro",
      flex: 1,
      valueGetter: (params) => dayjs(params, "DD/MM/YYYY", true).toDate(),
      renderCell: (params) => dayjs(params.value).format("DD/MM/YYYY"),
    },

    {
      field: " ",
      headerName: " ",
      maxWidth: 16,
      sortable: false,

      renderCell: (params) => (
        <IconButton
          onClick={() => downloadFatura(params.row.id_fatura)}
          size="small"
        >
          <LocalPrintshopOutlined fontSize="small" />
        </IconButton>
      ),
    },
  ];

  const columnsVero = [
    // Grupo econômico: exibe o cliente membro dono de cada fatura
    ...(clienteInfo?.isGrupoEconomico
      ? [
          {
            field: "ownerNome",
            headerName: "Cliente",
            flex: 1,
            renderCell: (params) => params?.row?.ownerNome || "",
          },
        ]
      : []),
    {
      field: "servico",
      headerName: "Contrato",
      flex: 1.5,
      valueGetter: (params, row) =>
        `${row?.id_cliente_servico || ""} - ${row?.nome || ""}`,
      renderCell: (params) => {
        if (!params?.row?.id_cliente_servico && !params?.row?.nome) return "";
        return `${params?.row?.id_cliente_servico} - ${params?.row?.nome}`;
      },
    },
    {
      field: "valor",
      headerName: "Valor da fatura",
      flex: 1,
      renderCell: (params) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(Number(params?.value || 0)),
    },
    {
      field: "data_vencimento",
      headerName: "Data Vencimento",
      flex: 1,

      valueGetter: (params) => (params ? dayjs(params).toDate() : null),
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,

      renderCell: (params) =>
        statusPagamento[params?.value?.toLowerCase()] || (
          <Chip label={params?.value} />
        ),
    },
    {
      field: "data_cadastro",
      headerName: "Data de Emissão",
      flex: 1,
      valueGetter: (params) => (params ? dayjs(params).toDate() : null),
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "valor_pago",
      headerName: "Valor Pago",
      flex: 1,
      renderCell: (params) =>
        params?.value
          ? new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(Number(params?.value || 0))
          : "",
    },
    {
      field: "data_pagamento",
      headerName: "Data de pagamento",
      flex: 1,
      valueGetter: (params) => (params ? dayjs(params).toDate() : null),
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: " ",
      headerName: " ",
      maxWidth: 16,
      sortable: false,
      renderCell: (params) => {
        // Verifica se veio um link externo ou se veio o ID do documento da Vero
        const hasLink = !!params?.row?.link;
        const hasDoc = !!params?.row?.cod_arq_doc;

        return (
          <IconButton
            disabled={!hasLink && !hasDoc}
            onClick={() => {
              if (hasLink) {
                window.open(params.row.link, "_blank", "noopener,noreferrer");
              } else if (hasDoc) {
                const baseUrl =
                  window?.config?.REACT_APP_BASE_URL ||
                  process.env.REACT_APP_BASE_URL ||
                  "";

                window.open(
                  `${baseUrl}/download/vero/fatura?faturaId=${params.row.id_fatura}&docId=${params.row.cod_arq_doc}`,
                  "_blank",
                );
              }
            }}
            size="small"
          >
            <LocalPrintshopOutlined fontSize="small" />
          </IconButton>
        );
      },
    },
  ];
  const columnsNf = [
    {
      field: "cliente",
      headerName: "Cliente",
      flex: 1,
      renderCell: (params) =>
        `${params?.row?.cliente?.codigo_cliente || ""}  - ${
          params?.row?.cliente?.nome || ""
        }`,
    },
    {
      field: "modelo",
      headerName: "Modelo",
      flex: 1,
    },
    {
      field: "dataEmissao",
      headerName: "Data de Emissão/Cadastro",
      flex: 1,
      valueGetter: (params) => {
        const date = dayjs(params).format("DD/MM/YYYY");
        return date;
      },
    },
    {
      field: " ",
      headerName: " ",
      maxWidth: 16,
      sortable: false,

      renderCell: (params) => (
        <IconButton
          onClick={() =>
            window.open(params.row.link, "_blank", "noopener,noreferrer")
          }
          size="small"
        >
          <LocalPrintshopOutlined fontSize="small" />
        </IconButton>
      ),
    },
  ];

  const columnsErp = {
    hubsoft: columnsHubsoft,
    voalle: columnsVoalle,
    ixc: columnsIxc,
    vero: columnsVero,
  };

  const filteredRows = rows?.filter((row) => {
    const valorFatura = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(Number(row?.valor || 0));

    const valorPago = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(Number(row?.valor_pago || 0));

    const servicoId =
      row?.id_cliente_servico ||
      row?.servico?.id_cliente_servico ||
      row?.cliente?.servico?.id_cliente_servico ||
      "";
    const servicoNome =
      row?.nome || row?.servico?.nome || row?.cliente?.servico?.nome || "";
    const stringServico = `${servicoId} - ${servicoNome}`;

    const dataVencimentoFormatada = row?.data_vencimento
      ? dayjs(row.data_vencimento).format("DD/MM/YYYY")
      : "";

    const matchesText =
      dataVencimentoFormatada?.includes(buscarFatura?.toLowerCase()) ||
      row.data_cadastro?.toLowerCase()?.includes(buscarFatura?.toLowerCase()) ||
      row.data_pagamento
        ?.toLowerCase()
        ?.includes(buscarFatura?.toLowerCase()) ||
      row.status
        ?.toString()
        ?.toLowerCase()
        ?.includes(buscarFatura?.toLowerCase()) ||
      valorFatura?.toLowerCase()?.includes(buscarFatura?.toLowerCase()) ||
      valorPago?.toLowerCase()?.includes(buscarFatura?.toLowerCase()) ||
      stringServico?.toLowerCase()?.includes(buscarFatura?.toLowerCase()) ||
      row.ownerNome?.toLowerCase()?.includes(buscarFatura?.toLowerCase());

    const matchesService =
      !selectService?.id_cliente_servico ||
      servicoId?.toString() === selectService?.id_cliente_servico?.toString();

    return matchesText && matchesService;
  });

  const filteredRowsNf = rowsNf?.filter((row) => {
    const matchesText =
      row.modelo?.toLowerCase()?.includes(buscarNf?.toLowerCase()) ||
      dayjs(row.dataEmissao)
        .format("DD/MM/YYYY")
        ?.toLowerCase()
        ?.includes(buscarNf?.toLowerCase());

    return matchesText;
  });
  const selectorComponentLeft = (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexGrow: 1 }}>
      {variosErps && (
        <ErpFilter
          erps={erps}
          value={erpId}
          onChange={handleChangeErp}
          limpavel={false}
          id="filtro-erp-boletos"
          sx={{ minWidth: 200 }}
        />
      )}
      <Box sx={styles.autocompleteFilter}>
        <VirtualizedAutocomplete
          value={selectedCliente}
          onChange={(_, newValue) => {
            setSelectedCliente(newValue);
            const clientStorage = {
              interfaceId: "",
              clienteId: newValue?.id,
              hostId: "",
              selectTime: 5,
              initialDate: "",
              finalDate: "",
            };

            localStorage.setItem("filterData", JSON.stringify(clientStorage));
          }}
          clearIcon={
            <Clear
              fontSize="small"
              onClick={() => {
                localStorage.removeItem("filterData");
                setSelectedCliente(null);
                /*   navigate("/interno/home/perfil/"); */
              }}
            />
          }
          size="small"
          // Só os clientes do ERP escolhido.
          options={(clientes || []).filter(doErp)}
          getOptionLabel={(option) =>
            getClienteOptionLabel(option)
          }
          renderOption={renderOpcaoCliente()}
          renderInput={(params) => (
            <CampoCliente
              params={params}
              option={selectedCliente}
              label="Cliente"
              sx={styles.filterAutocomplete}
            />
          )}
        />
      </Box>
    </Box>
  );
  const actions = [
    {
      icon: <FilterAltOutlinedIcon />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
  ];
  return (
    <Box sx={styles.boxComponent}>
      <FilterBar
        actions={actions}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        type={1}
        selectorComponentLeft={selectorComponentLeft}
      />
      <Paper
        sx={styles.containerPaper}
        elevation={theme.palette.mode === "dark" ? 0 : 3}
      >
        <Typography variant="mySubtitle">Faturas</Typography>
        <Box sx={styles.containerActions}>
          {" "}
          <Grid
            container
            spacing={1}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
          >
            <Grid item xs={12} sm={5} md={4} lg={3}>
              <TextField
                label="Buscar fatura"
                variant="outlined"
                autoComplete="off"
                placeholder={`${labelErp}, vencimento, etc...`}
                value={buscarFatura}
                size="small"
                onChange={(event) => {
                  setBuscarFatura(event?.target?.value?.trimStart());
                }}
                sx={styles.textField}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                  endAdornment: buscarFatura ? (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setBuscarFatura("")}
                        edge="end"
                      >
                        <Clear size={"small"} />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={5} md={4} lg={3}>
              <Autocomplete
                id="free-solo-demo"
                value={selectService}
                disabled={loading}
                size="small"
                options={allServices || []}
                getOptionLabel={(option) => {
                  if (option?.id_cliente_servico && option?.nome) {
                    return `${option.id_cliente_servico} - ${option.nome}`;
                  }
                  return "";
                }}
                onChange={(event, newValue) => {
                  setSelectService(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} label={labelErp} />
                )}
                filterOptions={(options, params) => {
                  // Se a pesquisa normal não encontrar nada, ou se você quiser forçar a busca em outros campos:
                  return options.filter(
                    (option) =>
                      option.nome
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()) ||
                      option.id_cliente_servico
                        ?.toString()
                        .includes(params.inputValue) ||
                      option.referencia
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()) ||
                      option.ownerNome
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()),
                  );
                }}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;

                  // Se não houver referência, renderiza o formato simples (padrão)
                  if (!option.referencia && !option.ownerNome) {
                    return (
                      <li key={key} {...optionProps}>
                        {`${option.id_cliente_servico} - ${option.nome}`}
                      </li>
                    );
                  }

                  // Se houver referência, renderiza o formato personalizado
                  return (
                    <li key={key} {...optionProps}>
                      <Box sx={styles.boxLine}>
                        <span style={{ fontWeight: "bold" }}>
                          {`${option.id_cliente_servico} - ${option.nome}`}
                        </span>
                        {option.referencia?.trim() && (
                          <>
                            <Divider sx={{ margin: "2px 0" }} />
                            <span style={{ fontSize: "0.85rem", opacity: 0.9 }}>
                              <span style={{ fontWeight: "bold" }}>
                                {configErpRef(option?.invertInfo).labelRef}:
                              </span>{" "}
                              {option.referencia}
                            </span>
                          </>
                        )}
                        {option.ownerNome && (
                          <>
                            <Divider sx={{ margin: "2px 0" }} />
                            <span style={{ fontSize: "0.85rem", opacity: 0.9 }}>
                              <span style={{ fontWeight: "bold" }}>
                                Cliente:
                              </span>{" "}
                              {option.ownerNome}
                            </span>
                          </>
                        )}
                      </Box>
                    </li>
                  );
                }}
              />
            </Grid>
          </Grid>
        </Box>
        <Box sx={styles.boxDatagrid}>
          <DatagridComponent
            loading={loading}
            rows={filteredRows}
            columns={columnsErpType ? columnsErp[columnsErpType] : []}
          />
        </Box>
      </Paper>
      {isNf && (
        <Paper
          sx={styles.containerPaper}
          elevation={theme.palette.mode === "dark" ? 0 : 3}
        >
          <Typography variant="mySubtitle">NFs</Typography>
          <Box sx={styles.containerActions}>
            {" "}
            <Grid
              container
              spacing={1}
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            >
              <Grid item xs={12} sm={5} md={4} lg={3}>
                <TextField
                  label="Buscar NF"
                  variant="outlined"
                  autoComplete="off"
                  placeholder="Modelo, data, etc..."
                  value={buscarNf}
                  size="small"
                  onChange={(event) => {
                    setBuscarNf(event?.target?.value?.trimStart());
                  }}
                  sx={styles.autocomplete}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                    endAdornment: buscarNf ? (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setBuscarNf("")} edge="end">
                          <Clear size={"small"} />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={5} md={4} lg={3}>
                <Autocomplete
                  id="free-solo-demo"
                  value={selectModelo}
                  disabled={loadingNf}
                  size="small"
                  options={allModeloNf || []}
                  getOptionLabel={(option) => option?.modelo || ""}
                  onChange={(event, newValue) => {
                    setSelectModelo(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Modelo" />
                  )}
                />
              </Grid>
            </Grid>
          </Box>
          <Box sx={styles.boxDatagrid}>
            <DatagridComponent
              loading={loadingNf}
              rows={filteredRowsNf}
              columns={columnsNf}
            />
          </Box>
        </Paper>
      )}
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}
